module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12345/images/product-images/default-product-image.png"